import { render, staticRenderFns } from "./OptionsPanelImageHeatMap.vue?vue&type=template&id=01dffb61&scoped=true"
import script from "./OptionsPanelImageHeatMap.vue?vue&type=script&lang=js"
export * from "./OptionsPanelImageHeatMap.vue?vue&type=script&lang=js"
import style0 from "./OptionsPanelImageHeatMap.vue?vue&type=style&index=0&id=01dffb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dffb61",
  null
  
)

export default component.exports